import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import config from '../../config';
import StudentList from '@components/StudentList/StudentList';
import { useOverviewContext } from '@context/OverviewContext';
import { useLinksContext } from '@/context/LinksContext';
import { handleLogout, openAccountLink } from '@/utils/linksUtils';

const LearningCoachDashboard: React.FC = () => {
  const {
    loggedInUser,
    students,
    userRoleVal,
    error,
  } = useOverviewContext();
  
  const { oktaAuth } = useOktaAuth();
  const { myAccountLink } = useLinksContext();

   
  if (error) {
    return <div className="container mt-5 text-danger">Error: {error}</div>;
  }

  if (userRoleVal !== 'LEARNING_COACH' || students.length <= 1) {
    return null;
  }

  return (
    <div className="lc-first-screen">
        <div className="top-nav">
            <div className="col d-flex justify-content-end">
                
              <a href="#" 
                 onClick={(e) => {
                   e.preventDefault();
                   openAccountLink(myAccountLink);
                 }} 
                 className="nav-link"
                 id="logout">Account
              </a>  
              &nbsp;&nbsp;|&nbsp;&nbsp; 
              
              <a href="#" 
                onClick={async (e) => {
                    e.preventDefault();
                    await handleLogout(oktaAuth, config.oidc.postLogoutRedirectUri);
                }}
                id="logout"
                className="nav-link">Logout
              </a>
            </div>
        </div>
        
        <div className="welcome-container">
            <div className="row">
                <div className="col-12 col-md-12 col-lg-6 mb-4">
                    <h2 className="lc-name">Welcome, {loggedInUser?.fname}!</h2>
                    <span className="lc-designation">Learning Coach</span>
                    <p className="lc-content">Here, you'll review school information and complete important tasks for your students to get ready for school. Select a student to get started.</p>
                </div>
                <div className="col-12 col-md-12 col-lg-6 student-switcher">
                    <div className='student-modal'>
                        <div className='student-modal-title'>
                            Select a student
                        </div>
                        <StudentList students={students} />
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default LearningCoachDashboard;